import { render } from "./MainMenuNew.vue?vue&type=template&id=1752cb66&scoped=true"
import script from "./MainMenuNew.vue?vue&type=script&lang=js"
export * from "./MainMenuNew.vue?vue&type=script&lang=js"

import "./MainMenuNew.vue?vue&type=style&index=0&id=1752cb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1752cb66"]])

export default __exports__